import { useState } from "react";
import { AttributeFieldProps } from "./RenderAttributeInput";
import { GetComponentOrStyleValueFromDefinition } from "../Data/WBData";


export default function RadioField({label,definition,layoutObject,updateFunc,screenSize,saveFunc}:AttributeFieldProps){

    let val = GetComponentOrStyleValueFromDefinition(definition,layoutObject,screenSize);

    const [currentSlection,setSelection] = useState(val);

    const updateAttribute =(newValue:string)=>{
   
        setSelection(newValue);
      updateFunc(definition.attKey,newValue,definition.targetType);

    }
    return (
      <div className={"wb-input-group " }>
        {definition.label &&
        <label className={(val=="")?"not-updated":"updated"}>{label}</label>
      }
        <div className="wb-input-row">
            <div className="flex-column gap-med" 
           
            >
          {definition.options.map((option, index) => {
            
    
            return (
                <div
                className="cursor-pointer flex-row gap-med"
                onClick={(e)=>{
                    updateAttribute(option.value);
                }}
                >
              <input type="radio"
                value={option.value}
           
                checked={option.value == currentSlection}
                key={index}
                onChange={(e)=>{
                    if(e.target.checked)
                    updateAttribute(e.target.value);
                }
                }
                // onClick={() => {
                //   updateAttribute(option.value);
                // }}
              />
               <div style={{fontWeight:"400",fontSize:"15px"}}> {option.label}</div>
            </div>
             
             
            );
          })}
        </div>
        </div>
      </div>
    );

}